import CustomerLogo from '../CustomerLogo';

const LogoWriter = () => {
  return (
    <CustomerLogo
      fill="currentColor"
      role="img"
      viewBox="0 0 94 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Writer logo</title>
      <path
        d="M4.05607 38.9649L0.852966 9H6.70212L8.3733 27.9069L10.0445 9H15.6151L17.2167 27.9069L18.8182 9H24.737L21.4643 38.9649H14.2921L12.795 24.5231L11.3675 38.9649H4.05607Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M26.4349 9H35.6265C37.0888 9 38.2145 9.33721 39.0037 10.0116C39.8161 10.6628 40.3615 11.593 40.64 12.8023C40.9185 13.9883 41.0578 15.5116 41.0578 17.372C41.0578 19.0697 40.8374 20.3953 40.3963 21.3488C39.9553 22.3023 39.1894 22.965 38.0985 23.3371C39.0037 23.5232 39.6536 23.9766 40.0482 24.6975C40.466 25.4185 40.6748 26.3952 40.6748 27.6278L40.6053 38.9649H34.7561V27.244C34.7561 26.4069 34.5936 25.872 34.2686 25.6395C33.9437 25.4068 33.3518 25.2906 32.493 25.2906V38.9649H26.4349V9ZM33.9553 20.093C34.7909 20.093 35.2087 19.1859 35.2087 17.372C35.2087 16.5813 35.1739 15.9883 35.1042 15.593C35.0347 15.1976 34.907 14.9302 34.7213 14.7907C34.5356 14.6279 34.2686 14.5465 33.9205 14.5465H32.5278V20.093H33.9553Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M42.7486 38.9649V9H48.5281V38.9649H42.7486Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M53.4916 38.9649V14.7558H49.9404V9H63.0314V14.7558H59.48V38.9649H53.4916Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M64.7193 38.9649V9H76.6962V14.7907H70.8122V20.6162H76.4525V26.2673H70.8122V33.1394H77.0791V38.9649H64.7193Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M78.5449 9H87.7362C89.1983 9 90.3246 9.33721 91.1133 10.0116C91.926 10.6628 92.4712 11.593 92.7498 12.8023C93.0284 13.9883 93.1677 15.5116 93.1677 17.372C93.1677 19.0697 92.9472 20.3953 92.5063 21.3488C92.0653 22.3023 91.2996 22.965 90.2084 23.3371C91.1133 23.5232 91.7637 23.9766 92.1585 24.6975C92.5755 25.4185 92.7848 26.3952 92.7848 27.6278L92.7148 38.9649H86.8663V27.244C86.8663 26.4069 86.7039 25.872 86.3783 25.6395C86.0536 25.4068 85.4614 25.2906 84.6029 25.2906V38.9649H78.5449V9ZM86.0655 20.093C86.9004 20.093 87.3183 19.1859 87.3183 17.372C87.3183 16.5813 87.2841 15.9883 87.2141 15.593C87.1448 15.1976 87.0167 14.9302 86.8312 14.7907C86.6458 14.6279 86.3783 14.5465 86.0305 14.5465H84.6377V20.093H86.0655Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </CustomerLogo>
  );
};

export default LogoWriter;
